<div class="m-5" *ngIf="!event">
    <app-spinner></app-spinner>
</div>
<div tabindex="0" class="checkout mt-5">
    <div class="card col-md-10 offset-md-1 col-xl-8 offset-xl-2">
        <div class="row">
            <div class="card-header">
                <div class="confirmtext-container" *ngIf="this.confirmtext!=null">
                    <h2 class="confirmtext-container context" role="alert"  [innerText]="this.confirmtext"></h2>
                </div>
                <div class="default-banner" *ngIf="this.confirmtext == null">
                    <h2 class="context">
                    <span [appTranslate]="'ThankYouForRegistering'" aria-live="polite" role="alert" aria-label="Thank you for registering for the event!">Thank you for registering for the event!</span>
                    </h2>
                </div>
            </div>
        </div>
    </div>
</div>
